import { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import WaveLoader from '@/components/WaveLoader';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const MAGIC_KEY = 'lifetunes2026';

export default function MagicAccessPage() {
  const { key } = useParams();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    if (key !== MAGIC_KEY) {
      window.location.href = '/login';
      return;
    }

    const xhr = new XMLHttpRequest();
    xhr.open('POST', `${API_URL}/api/auth/magic-access`);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.withCredentials = true;
    xhr.onload = function () {
      if (xhr.status === 200) {
        // Hard redirect so page reloads and AuthContext picks up the cookie
        window.location.href = '/dashboard';
      } else {
        window.location.href = '/login';
      }
    };
    xhr.onerror = function () {
      window.location.href = '/login';
    };
    xhr.send(JSON.stringify({ key: MAGIC_KEY }));
  }, [key]);

  return <WaveLoader label="Granting access" />;
}
